export default "__VITE_ASSET__BzH98B1r__"